// extracted by mini-css-extract-plugin
export default {"datePickerIcon":"CustomDatePickerInput_datePickerIcon__ZErE4"};